import { createStore } from 'owa-satcheljs';
import { type TeamsClientState } from './schema/TeamsClientState';

export const getStore: () => TeamsClientState = createStore<TeamsClientState>('teamsClientStore', {
    sdkState: 'sdkLoading',
    unreadConversationsCount: 0,
});
